export function Default() {
  return {
    listMsopReportApi: {loading: false, data: [], error: false},
  };
}
